import { EProductPublishRequest } from '@gelato-api-ui/core/e-commerce/e-product-publish-request';
import { EProductPublishScopes } from '@gelato-api-ui/core/e-commerce/e-product-publish-scopes';

export const EProductPublishRequestDefaultValues: EProductPublishRequest = {
  scopes: EProductPublishScopes,
  withFreeShipping: false,
  isVisibleInTheOnlineStore: true,
  isInstant: false,
};
